<template>
  <div class="locale-changer">
    <Dropdown
      v-model="activeLang"
      :options="optionLanguages"
      placeholder=""
      :class="customclass"
      @change="changeLocale"
      v-if="languages"
    >
      <template #value="slotProps" v-if="activeLang != ''">
        <img
          src="/assets/flags/flag_placeholder.png"
          :class="'flag flag-' + lang[slotProps.value.code].flag"
          width="30"
        />
        {{ slotProps.value.name }}
      </template>
      <template #option="slotProps">
        <img
          src="/assets/flags/flag_placeholder.png"
          :class="'flag flag-' + lang[slotProps.option.code].flag"
          width="30"
        />
        {{ slotProps.option.name }}
      </template>
    </Dropdown>
  </div>
</template>

<script>
import { loadLanguageAsync } from "../i18n";

export default {
  props: {
    customclass: String,
  },
  data() {
    return {
      activeLang: "",
      lang: {
        de: {
          flag: "de",
          name: "Deutsch",
        },
        en: {
          flag: "gb",
          name: "English",
        },
        es: {
          flag: "es",
          name: "Español",
        },
        it: {
          flag: "it",
          name: "Italiano",
        },
        fr: {
          flag: "fr",
          name: "Français",
        },
        nl: {
          flag: "nl",
          name: "Ned",
        },
        pl: {
          flag: "pl",
          name: "Pol",
        },
        pt: {
          flag: "pt",
          name: "Pt",
        },
      },
    };
  },
  computed: {
    languages: function() {
      return this.$store.getters["labels/languages"];
    },
    locale: function() {
      return this.$store.getters["preferences/locale"] != null
        ? this.$store.getters["preferences/locale"]
        : "it";
    },
    optionLanguages() {
      return this.languages.filter((obj) => {
        return obj.code !== this.locale;
      });
    },
  },
  async mounted() {
    this.activeLang = this.languages.find((obj) => {
      return obj.code === this.locale;
    });
  },
  methods: {
    changeLocale: async function() {
      this.$store.commit("preferences/locale", this.activeLang.code);
      await loadLanguageAsync(this.activeLang.code);
      this.$i18n.locale = this.activeLang.code;
    },
  },
};
</script>

<style>
.rightbar-local-changer {
  width: 100%;
  background-color: rgb(252, 251, 251);
}
.p-dropdown-panel {
  background-color: rgb(252, 251, 251);
}
</style>
